import { render, staticRenderFns } from "./toNextBtn.vue?vue&type=template&id=dc1a5c30&scoped=true&"
import script from "./toNextBtn.vue?vue&type=script&lang=js&"
export * from "./toNextBtn.vue?vue&type=script&lang=js&"
import style0 from "./toNextBtn.vue?vue&type=style&index=0&id=dc1a5c30&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1a5c30",
  null
  
)

export default component.exports